import { ActionType, getType } from "typesafe-actions";
import * as search from "./search-actions";
import update from "immutability-helper";
import { IProduct } from "~/types/product";
export type SearchAction = ActionType<typeof search>;

// Need at least one of these themeCodes/searchString/complexQuery
export interface ISearchParams {
    themeCodes?: string[];
    searchString?: string;
    complexQuery?: string;
    page?: number;
    loadMorePageSize?: number;
    facets?: string[];
    sorting?: string;
}

export interface ISearchState {
    readonly isSearchPending: boolean;
    readonly searchParams: ISearchParams;
    readonly products?: IProduct[];
    readonly displayedProductsOutOfTotalLabel?: string;
    readonly productsTotalCount?: number;
    readonly productsTotalCountLabel?: string;
}

export const initialState: ISearchState = {
    isSearchPending: false,
    searchParams: {}
};

const searchReducer = (state: ISearchState = initialState, action: SearchAction) => {
    switch (action.type) {
        case getType(search.searchRequest):
            return update(state, {
                isSearchPending: { $set: true }
            });
        case getType(search.searchSuccess):
            return update(state, {
                isSearchPending: { $set: false },
                products:
                    // When sorting/filtering params are changed, the page resets to "0".
                    // In that case, we override the products in the store rather than appending
                    action.payload.page !== 0
                        ? { $push: action.payload.products }
                        : { $set: action.payload.products },
                displayedProductsOutOfTotalLabel: { $set: action.payload.displayedProductsOutOfTotalLabel },
                productsTotalCount: { $set: action.payload.productsTotalCount },
                productsTotalCountLabel: { $set: action.payload.productsTotalCountLabel }
            });
        case getType(search.searchError):
            return update(state, { isSearchPending: { $set: false } });
        case getType(search.populateSearch):
            return update(state, { products: { $set: action.payload.products } });
        case getType(search.updateSearchParams):
            return update(state, { searchParams: { $merge: action.payload } });
        default:
            return state;
    }
};

export default searchReducer;
